import api from '@/services/api'

export default {
    publication(payload) {
        return api.post(`ok/publication/`, payload)
            .then(response => response.data)
    },
    getGroups(params) {
        return api.get(`ok/groups/`, {params})
            .then(response => response.data)
    },
    getAlbums(params) {
        return api.get(`ok/albums/`, {params})
            .then(response => response.data)
    },
    getPhotos(params) {
        return api.get(`ok/photos/`, {params})
            .then(response => response.data)
    }
}